import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How does custom software development help my business?",
    answer: `<p>Modern businesses are opting for technology solutions that are helping them grow and expand their digital footprint. If you own and run a business, a customized software solution can help you optimize your operations, remove efficiencies, and expedite the work – eventually leading to business prosperity and growth.</p>`,
  },
  {
    question:
      "Should I be familiar with the technical details of working with you?",
    answer: `<p>Having know-how of technicalities is always a plus, but do you need to have a technical understanding of TekRevol? Absolutely not. We work around the globe, serving businesses of all sizes and industries, and it is our job to provide them with a technical solution. All you need to do is to tell us the way you want things to work, and we will shape the process to your ideal outcome.</p>`,
  },
  {
    question: " What information do you need from me to start work?",
    answer: `<p>Whatever you are looking to build for your business, we want that information to be shared with us. That is all that we need to make the necessary documents and plan the work, and once you approve them and sign the contract, the work can begin instantly. So, whether you are looking for Android app development services or seeking to hire Android app developers, we can do all that for you – you just have to share the details with us.</p>`,
  },
  {
    question:
      " Do you provide product support services after the software development is complete?",
    answer: `<p>TekRevol is a full-cycle software development company in Houston with years of technology experience. We provide complete support before production and after the product launch. From routine maintenance to product updates to optimization and more – we do it all to deliver in the best possible manner for our clients. TekRevol is also a renowned iPhone development company, so for all your iPhone development needs, you now know where to look.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
